import React from 'react';
import { cn } from '@/lib/utils';
import { getParameterConfig, ParameterType } from './parameter-config';

interface ParameterTagProps {
  parameter: ParameterType;
  className?: string;
  noText?: boolean;
}

export function ParameterTag({ parameter, className, noText=false }: ParameterTagProps) {
  const config = getParameterConfig(parameter);

  return (
    <div className={cn("flex items-center h-5 px-1 rounded-[4px] gap-1", config.color, className)}>
      {config.icon}
      {
        !noText &&
        <span className={cn("paragraph-9 m-0", config.textColor)}>
          {config.text}
        </span>
      }
    </div>
  );
}